import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import {
    Divider,
    Modal,
    Spin,
    TimePicker,
    Tooltip,
    message,
    Button as AntButton,
    Row,
    Typography,
    Table,
    Card,
    Col,
    Tag,
    Collapse,
} from 'antd'
import {
    EditOutlined,
    CloseSquareOutlined,
    CheckSquareOutlined,
} from '@ant-design/icons'

// redux
import { reportsActions } from './redux/slice'
import { editTimeWithTask, timesheetApi } from './redux/apis'

// components
import ReportDocument from './reportDocument'

import dayjs from 'dayjs'
import Button from '../../../components/button/button'
import { projectReportsState } from '../projectReports/projectReports.slice'
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer'
import WorkReportFlatTable from '../../../components/WorkReportFlatTable/WorkReportFlatTable'
import { formatMilliseconds } from '../../../utils/commonUtils'

const EditReport = ({ isEditReport, setIsEditReport }) => {
    const { Title, Text } = Typography

    const dispatch = useDispatch()
    const { isLoading } = useSelector((state) => state.reportTimesheet)
    const pdfDataInRedux = useSelector((state) => state.reportTimesheet)
    const pdfData = pdfDataInRedux?.pdfData
    const projectData = pdfDataInRedux?.pdfSelectedData


    const { dateRanges } = useSelector(projectReportsState)
    const [totalHours, setTotalHours] = useState(0)
    const [isGeneratePdf, setIsGeneratePdf] = useState(false)
    const [selectedTask, setSelectedTask] = useState(null)
    const [selectedTaskTime, setSelectedTaskTime] = useState(null)
    // const [isLoadData, setLoadData] = useState(false)
    const [isLoadDataGeneratePdf, setLoadDataGeneratePdf] = useState(false)
    const [editedTimeLogs, setEditedTimeLogs] = useState({})


    useEffect(() => {
        if (editedTimeLogs?.tableBody?.length > 0) {
            let hours = editedTimeLogs?.tableBody.map(
                (data) =>
                    data?.list?.length > 0 &&
                    data?.list.reduce(function (acc, obj) {
                        return acc + obj?.totalLog?.total
                    }, 0)
            )
            const sum = hours.reduce((partialSum, a) => partialSum + a, 0)
            setTotalHours(sum)
            setIsGeneratePdf(false)
        }
    }, [editedTimeLogs?.tableBody])

    const handleEditTime = (task) => {
        setSelectedTask(task)
        setIsGeneratePdf(false)
    }

    const handleGeneratePDF = () => {
        setLoadDataGeneratePdf(true)
        setTimeout(() => {
            setLoadDataGeneratePdf(false)
            setIsGeneratePdf(true)
        }, 1500)
    }

    function hourMinuteSecond(timeInMilliseconds, type) {
        let h, m, s
        h = Math.floor(timeInMilliseconds / 1000 / 60 / 60)
        m = Math.floor((timeInMilliseconds / 1000 / 60 / 60 - h) * 60)
        s = Math.floor(
            ((timeInMilliseconds / 1000 / 60 / 60 - h) * 60 - m) * 60
        )

        if (type === 'edit') {
            return `${h}:${m}:${s}s`
        } else {
            return `${h}h ${m}m ${s}s`
        }
    }

    // const handleSaveChangeTime = async () => {
    //     // set logic of pervious time and new time and update api call

    //     if (selectedTask) {
    //         setLoadData(true)
    //         let endLog = selectedTask?.timelogs?.end
    //             ? selectedTask?.timelogs?.end
    //             : new Date().getTime()
    //         let timeDiff = endLog - selectedTask.timelogs?.start

    //         // Default editedTime to 0 if selectedTaskTime is null
    //         let editedTime = 0

    //         if (selectedTaskTime !== null) {
    //             editedTime =
    //                 (selectedTaskTime['$H'] * 60 * 60 +
    //                     selectedTaskTime['$m'] * 60 +
    //                     selectedTaskTime['$s']) *
    //                 1000
    //         }

    //         let latestTimeDiff =
    //             editedTime > timeDiff
    //                 ? editedTime - timeDiff
    //                 : timeDiff - editedTime
    //         let newEndLog =
    //             editedTime > timeDiff
    //                 ? endLog + latestTimeDiff
    //                 : endLog - latestTimeDiff

    //         // send api data in payload

    //         const data = {
    //             id: selectedTask?._id,
    //             index: selectedTask?.index,
    //             newEndLog,
    //         }

    //         const updatedRes = await editTimeWithTask(data)

    //         if (updatedRes?.data?.success) {
    //             message.success(updatedRes?.data?.message)
    //             setSelectedTask(null)
    //             setSelectedTaskTime(null)

    //             let assigneesId = projectData?.assignees?.map((v) => v.value)

    //             const reportNewData = {
    //                 projectId: projectData?.project?.id,
    //                 start: projectData?.start,
    //                 end: projectData?.end,
    //                 assigneeId: assigneesId,
    //             }

    //             const reportRes = await timesheetApi(reportNewData)
    //             if (reportRes?.data?.success) {
    //                 setLoadData(false)
    //                 dispatch(
    //                     reportsActions.downloadPdfData({
    //                         pdfData: reportRes?.data,
    //                         pdfSelectedData: projectData,
    //                     })
    //                 )
    //                 setIsGeneratePdf(false)
    //             } else {
    //                 setLoadData(false)
    //                 message.error(reportRes?.data?.message)
    //                 setIsGeneratePdf(false)
    //             }
    //         } else {
    //             setLoadData(false)
    //             message.error(updatedRes?.data?.message)
    //             setIsGeneratePdf(false)
    //         }
    //     } else {
    //         message.error('Please select time properly')
    //     }
    // }

    useEffect(() => {
        setEditedTimeLogs(pdfData)
    }, [pdfData])

    // const handleSaveChangeTime = async () => {
    //     if (!selectedTask) {
    //         message.error('Please select time properly');
    //         return;
    //     }

    //     setLoadData(true);

    //     try {
    //         // 1️⃣ Get current end time (existing or now)
    //         const endLog = selectedTask?.timelogs?.end
    //             ? selectedTask.timelogs.end
    //             : new Date().getTime();

    //         // 2️⃣ Calculate total time already logged
    //         const timeDiff = endLog - selectedTask.timelogs.start;

    //         // 3️⃣ Calculate edited time based on selectedTaskTime
    //         let editedTime = 0;
    //         if (selectedTaskTime !== null) {
    //             editedTime = selectedTaskTime.diff(selectedTaskTime.startOf('day'));
    //         }

    //         // 4️⃣ Calculate newEndLog logic
    //         let latestTimeDiff;
    //         let newEndLog;
    //         if (editedTime > timeDiff) {
    //             latestTimeDiff = editedTime - timeDiff;
    //             newEndLog = endLog + latestTimeDiff;
    //         } else {
    //             latestTimeDiff = timeDiff - editedTime;
    //             newEndLog = endLog - latestTimeDiff;
    //         }

    //         // 5️⃣ Prepare and send the updated time payload
    //         const data = {
    //             id: selectedTask._id,
    //             index: selectedTask.index,
    //             newEndLog,
    //             reportUpdateDate: dateRanges?.start // Assuming you want this in payload
    //         };

    //         const updatedRes = await editTimeWithTask(data);

    //         if (updatedRes?.data?.success) {
    //             message.success(updatedRes.data.message);
    //             setSelectedTask(null);
    //             setSelectedTaskTime(null);

    //             // 6️⃣ Re-fetch reports if necessary
    //             const assigneesId = projectData?.assignees?.map(v => v.value);
    //             const reportNewData = {
    //                 projectId: projectData?.project?.id,
    //                 start: projectData?.start,
    //                 end: projectData?.end,
    //                 assigneeId: assigneesId,
    //             };

    //             const reportRes = await timesheetApi(reportNewData);

    //             if (reportRes?.data?.success) {
    //                 dispatch(
    //                     reportsActions.downloadPdfData({
    //                         pdfData: reportRes?.data,
    //                         pdfSelectedData: projectData,
    //                     })
    //                 );
    //                 setLoadData(false);
    //                 setIsGeneratePdf(false);
    //             } else {
    //                 message.error(reportRes?.data?.message || 'Failed to generate report');
    //                 setLoadData(false);
    //                 setIsGeneratePdf(false);
    //             }
    //         } else {
    //             message.error(updatedRes?.data?.message || 'Failed to update task time');
    //             setLoadData(false);
    //             setIsGeneratePdf(false);
    //         }
    //     } catch (err) {
    //         console.error("API Error:", err);
    //         message.error('Something went wrong while saving changes');
    //         setLoadData(false);
    //         setIsGeneratePdf(false);
    //     }
    // };

    const handleCancleTime = () => {
        // cancle icon
        setSelectedTask(null)
        setSelectedTaskTime(null)
        setIsGeneratePdf(false)
    }

    const handleTimePickerValChange = (val) => {
        // time picker value
        if (val) {
            setSelectedTaskTime(val)
        } else {
            setSelectedTaskTime(null)
        }
    }

    return (
        <>
            <Modal
                closable={false}
                open={isEditReport}
                destroyOnClose={true}
                footer={
                    <>
                        <Divider style={{ margin: "0" }} />
                        <Row justify={"end"} style={{ padding: "10px 20px 18px" }}>
                            <Col>
                                <Button
                                    props={{
                                        text: 'Cancel',
                                        onClick: () => {
                                            setIsEditReport(false);
                                            dispatch(
                                                reportsActions.downloadPdfData({
                                                    pdfData: null,
                                                    pdfSelectedData: null,
                                                })
                                            );
                                        },
                                        style: { color: "#555", background: "transparent", marginRight: "10px" }
                                    }}
                                />
                                {pdfData?.tableBody?.length > 0 &&
                                    (!isGeneratePdf ? (
                                        <>

                                            <PDFDownloadLink
                                                document={
                                                    <ReportDocument
                                                        pdfData={editedTimeLogs}
                                                        selectPdfData={projectData}
                                                    />
                                                }
                                                // fileName={projectData?.project?.name}

                                                fileName={`${projectData?.project?.name ? projectData?.project?.name + '-Reports' : 'Reports'}-${dayjs(projectData?.start).format('DD-MM-YYYY')} to ${dayjs(projectData?.end).format('DD-MM-YYYY')}.pdf`}

                                                style={{ textDecoration: 'none' }}
                                            >
                                                <Button
                                                    props={{
                                                        text: 'Download PDF',
                                                        onClick: () => { },
                                                    }}
                                                />
                                                {/* {({ loading }) => (loading ? 'Loading document...' : 'Download now!')} */}
                                            </PDFDownloadLink>
                                        </>

                                    ) : (
                                        <Button
                                            props={{
                                                text: 'Generate PDF',
                                                loadingButton:
                                                    isLoadDataGeneratePdf,
                                                disabled: isLoadDataGeneratePdf,
                                                onClick: handleGeneratePDF,

                                            }}
                                        />
                                    ))}

                            </Col>
                        </Row>
                    </>
                }
                styles={{
                    body: {
                        maxHeight: '450px',
                        overflowY: 'auto',
                        // overflowX: 'hidden',
                        scrollbarGutter: 'stable',
                        paddingRight: 0,
                    },
                    content: {
                        padding: "0px"
                    }
                }}
                title={
                    <>
                        <Row
                            // style={{ maxWidth: '99%' }}
                            justify="space-between"
                            align={"middle"}
                            gutter={[16, 16]}
                            style={{ padding: "18px 20px 0px" }}
                        >
                            <Col flex="1">
                                <Title level={4} style={{ margin: 0 }}>
                                    {projectData?.project?.name}
                                </Title>
                            </Col>

                            <Col>
                                <Tag color="blue" style={{ fontSize: 14 }}>
                                    {hourMinuteSecond(totalHours)}
                                </Tag>
                            </Col>

                            <Col>
                                <Text>
                                    {dayjs(projectData?.start).format(
                                        'DD MMM YYYY'
                                    )}{' '}
                                    -{' '}
                                    {dayjs(projectData?.end).format(
                                        'DD MMM YYYY'
                                    )}
                                </Text>
                            </Col>
                        </Row>
                        <Divider style={{ margin: '0', marginTop: '15px' }} />
                    </>
                }
                width={'1000px'}
                onCancel={() => {
                    setIsEditReport(false)
                    dispatch(
                        reportsActions.downloadPdfData({
                            pdfData: null,
                            pdfSelectedData: null,
                        })
                    )
                }}
            // style={{ padding: "20px" }}
            >
                <>
                    {/* Loading State */}
                    {isLoading ? (
                        <div
                            style={{
                                width: '100%',
                                height: '30vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Spin />
                        </div>
                    ) : (
                        <>
                            {editedTimeLogs?.tableBody?.length > 0 ? (
                                editedTimeLogs.tableBody.map((item, idx) =>
                                    projectData?.assignees?.map((assignee) =>
                                        assignee.value ===
                                            item._id?.assigneeId ? (
                                            <Card
                                                key={`${assignee.value}_${idx}`}
                                                title={
                                                    <Row
                                                        justify="space-between"
                                                        align="middle"
                                                    >
                                                        <Col>
                                                            <Text
                                                                strong
                                                                style={{
                                                                    fontSize: 16,
                                                                }}
                                                            >
                                                                {assignee.label}
                                                            </Text>
                                                        </Col>
                                                        <Col>
                                                            <Tag color="geekblue">
                                                                {hourMinuteSecond(
                                                                    item?.list.reduce(
                                                                        (
                                                                            acc,
                                                                            obj
                                                                        ) =>
                                                                            acc +
                                                                            obj
                                                                                .totalLog
                                                                                .total,
                                                                        0
                                                                    )
                                                                )}
                                                            </Tag>
                                                        </Col>
                                                    </Row>
                                                }
                                                bordered={false}
                                                style={{
                                                    marginBottom: 16,
                                                    borderRadius: '10px',
                                                    backgroundColor: '#fafafa',
                                                    // marginTop: '10px',
                                                    margin: "15px 20px 0px"
                                                }}
                                            >
                                                {item?.list?.length > 0 &&
                                                    item.list.map(
                                                        (row, rowIdx) => (
                                                            <Collapse
                                                                key={rowIdx}
                                                                ghost
                                                                expandIconPosition="end"
                                                                style={{
                                                                    marginBottom: 10,
                                                                    background:
                                                                        '#fff',
                                                                    borderRadius: 6,
                                                                }}
                                                                items={[
                                                                    {
                                                                        key: rowIdx,
                                                                        label: (
                                                                            <Row
                                                                                justify="space-between"
                                                                                align="middle"
                                                                            >
                                                                                <Col>
                                                                                    <Text>
                                                                                        {
                                                                                            row
                                                                                                ?._id
                                                                                                ?.startLogDate
                                                                                        }
                                                                                    </Text>
                                                                                </Col>
                                                                                <Col>
                                                                                    <Tag>
                                                                                        {hourMinuteSecond(
                                                                                            row
                                                                                                ?.totalLog
                                                                                                ?.total
                                                                                        )}
                                                                                    </Tag>
                                                                                </Col>
                                                                            </Row>
                                                                        ),
                                                                        children:
                                                                            (
                                                                                <WorkReportFlatTable
                                                                                    tableBody={
                                                                                        row ||
                                                                                        []
                                                                                    }
                                                                                    editedTimeLogs={editedTimeLogs}
                                                                                    setEditedTimeLogs={setEditedTimeLogs}
                                                                                />
                                                                            ),
                                                                    },
                                                                ]}
                                                            />
                                                        )
                                                    )}
                                            </Card>
                                        ) : null
                                    )
                                )
                            ) : (
                                <Text style={{ padding: " 5px 20px " }}>No data available</Text>
                            )}
                        </>
                    )}
                </>
            </Modal>
        </>
    )
}

export default EditReport
